import React, { Fragment } from 'react';
import SiteHeader from '../../../components/SiteHeader';
import { Link } from 'react-router-dom';
import FooterArea from '../../../components/FooterArea';
import Seo from '../../../components/Seo';

const NotFound = () => (
    <Fragment>
        <Seo title="404 — Page Not Found" path="/404" noindex />
        <SiteHeader />
        <main
            style={{
                maxWidth: 720,
                margin: '0 auto',
                padding: '110px 20px',
                textAlign: 'center',
            }}
        >
            <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 72, color: '#b8860b', margin: 0 }}>404</h1>
            <h2 style={{ fontFamily: "'Playfair Display', serif", color: '#1a2b48', marginTop: 8 }}>Page Not Found</h2>
            <p style={{ fontFamily: "'Inter', sans-serif", color: '#6b7280', marginTop: 12, lineHeight: 1.7 }}>
                The page you’re looking for doesn’t exist or has been moved. Let’s get you back on track.
            </p>
            <div style={{ marginTop: 26, display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/" style={{ background: '#1a2b48', color: '#fff', padding: '12px 26px', borderRadius: 8, textDecoration: 'none', fontFamily: "'Inter', sans-serif", fontWeight: 600 }}>Back to Home</Link>
                <Link to="/practice" style={{ background: '#b8860b', color: '#fff', padding: '12px 26px', borderRadius: 8, textDecoration: 'none', fontFamily: "'Inter', sans-serif", fontWeight: 600 }}>Our Services</Link>
            </div>
        </main>
        <FooterArea />
    </Fragment>
);

export default NotFound;
